// src/pages/Partner/PartnerPlaceholder.jsx
import { Construction } from "lucide-react";

export default function PartnerPlaceholder({
  eyebrow = "Partner Portal",
  title,
  description,
}) {
  return (
    <section className="rounded-[28px] border border-[#EFEFEF] bg-white p-6 shadow-sm md:p-8">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFF4EC] text-[#FF914D]">
        <Construction className="h-7 w-7" />
      </div>

      <p className="mt-6 text-xs font-black uppercase tracking-wider text-[#FF914D]">
        {eyebrow}
      </p>

      <h1 className="mt-2 text-[34px] font-black tracking-[-0.03em] md:text-[42px]">
        {title}
      </h1>

      <p className="mt-3 max-w-3xl text-sm leading-relaxed text-[#757575] md:text-base">
        {description}
      </p>

      <div className="mt-7 rounded-2xl border border-[#FFE1CF] bg-[#FFF7ED] p-5 text-sm leading-relaxed text-[#75523B]">
        The secure partner organisation and cohort foundation
        is connected. This section will be implemented in a
        later phase.
      </div>
    </section>
  );
}